import { darken } from "@mui/material";
import { CloudUpload as CloudUploadIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useDropzone, DropzoneOptions } from "react-dropzone";
import styled from "styled-components";
import clsx from "clsx";

import { AcceptedFiles } from "./Dropzone/AcceptedFiles";
import { RejectedFiles } from "./Dropzone/RejectedFiles";

interface Props {
  dropzoneOptions: DropzoneOptions;
  className?: string;
}

export function Dropzone(props: Props) {
  const { acceptedFiles, fileRejections, getRootProps, getInputProps, isDragActive } = useDropzone({
    ...props.dropzoneOptions,
  });
  const { t } = useTranslation();

  return render();

  function render() {
    return (
      <Styles className={props.className}>
        <div {...getRootProps()} className={clsx("dnd-zone", { hovering: isDragActive })}>
          <input {...getInputProps()} className="file-input" />

          <CloudUploadIcon className="icon" />

          {isDragActive ? (
            <p>{t("label.dropTheFilesHere")}</p>
          ) : (
            <p>{t("label.dragAndDropFilesHereOrClickToSelectFiles")}</p>
          )}
        </div>

        <AcceptedFiles acceptedFiles={acceptedFiles} />
        <RejectedFiles rejectedFiles={fileRejections} supportedFormats={props.dropzoneOptions.accept} />
      </Styles>
    );
  }
}

const Styles = styled.div`
  .dnd-zone {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10%;
    padding: ${({ theme }) => theme.spacing(3, 3)};
    min-height: 140px;
    color: ${({ theme }) => theme.palette.text.primary};
    border: 1px dashed #dfdfdf;
    border-radius: ${({ theme }) => theme.shape.borderRadius}px;

    cursor: pointer;

    transition: all 150ms;

    .icon {
      flex: 0 0 30%;
      width: 100%;
      max-width: 50px;
      height: 100%;
      fill: #dfdfdf;
    }

    &:hover,
    &.hovering {
      border-color: ${darken("#dfdfdf", 0.2)};

      .icon {
        fill: ${darken("#dfdfdf", 0.2)};
      }
    }
  }
`;
